<ng-template #outdatedBrowserModal let-c="close" let-d="dismiss">
  <div class="modal-header brd-fill">
    <div class="outdated-browser-warning-message"
         [innerHTML]="'OUTDATED_BROWSER_MODAL.HEADER.MESSAGE' | translate">
    </div>
  </div>
  <div class="modal-body">
    <div class="outdated-browser-warning-submessage">
      {{ 'OUTDATED_BROWSER_MODAL.BODY.MESSAGE' | translate }}
      <ul class="mb-0">
        <li><a href="https://www.google.com/chrome/" target="_blank">
          {{ 'OUTDATED_BROWSER_MODAL.BODY.BROWSERS.CHROME' | translate }}
        </a></li>
        <li><a href="https://www.microsoft.com/edge" target="_blank">
          {{ 'OUTDATED_BROWSER_MODAL.BODY.BROWSERS.EDGE' | translate }}
        </a></li>
        <li><a href="https://www.opera.com/download" target="_blank">
          {{ 'OUTDATED_BROWSER_MODAL.BODY.BROWSERS.OPERA' | translate }}
        </a></li>
        <li><a href="https://brave.com/download/" target="_blank">
          {{ 'OUTDATED_BROWSER_MODAL.BODY.BROWSERS.BRAVE' | translate }}
        </a></li>
      </ul>
    </div>
   </div>
  <div class="modal-footer center" *ngIf="isBrowserSupported">
    <button type="button" class="btn btn-outline-dark continue-with-outdated-browser-btn" (click)="continueWithoutChrome(); c('Save click')">
      {{ 'OUTDATED_BROWSER_MODAL.FOOTER.CONTINUE_BUTTON' | translate }}
    </button>
  </div>
</ng-template>

<div class="main-content-wp">
  <app-header [frontendSelectedDependency]="frontendSelectedDependency"></app-header>
  <router-outlet></router-outlet>
  <app-notification></app-notification>
</div>

<div *ngIf="loaderService.isLoad$ | async" class="filter-loader-container">
  <app-filter-loader></app-filter-loader>
</div>

<ng-container *ngIf="versionService.isVersionChanges$ | async">
  <div class="alert-warning p-3 mb-3 mt-3 rounded refresh-alert">
    <div class="refresh-message">
      {{ 'VERSION_UPDATE_ALERT.MESSAGE' | translate }}
    </div>
    <button class="btn btn-primary" (click)="refresh()">
      {{ 'VERSION_UPDATE_ALERT.RELOAD_BUTTON' | translate }}
    </button>
  </div>
</ng-container>


<app-footer *ngIf="frontendSelectedDependency?.showFooter" [frontendSelectedDependency]="frontendSelectedDependency"></app-footer>


